import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetDriverTerminalProps } from '../Dashboard.types';

interface DriverTerminalFiltersProps {
 control: Control<WidgetDriverTerminalProps>;
 setValue: UseFormSetValue<WidgetDriverTerminalProps>;
 errors: FieldErrors<WidgetDriverTerminalProps>;
}

const DriverTerminalFilters: React.FC<DriverTerminalFiltersProps> = ({
 control,
 setValue,
}) => {
 const { t } = useTranslation();
 const terminalFilter = JSON.stringify({
  fields: 'Id,Name',
  filters: [
   { field: 'DeviceType', operator: 'eq', value: 'DriverTerminalView' },
  ],
  limit: 50,
 });

 return (
  <SelectApi<WidgetDriverTerminalProps>
   name="driverTerminal"
   url="/api/iot/v1/"
   filter={terminalFilter}
   label={t('dashboard.filters.driverTerminal')}
   isEditable
   operator="contains"
   control={control}
   setValue={setValue}
  />
 );
};

export default DriverTerminalFilters;
